import {
  AppItem,
  Body1Strong,
  Caption1,
  makeStyles,
  Subtitle2,
  tokens,
} from '@fluentui/react-components'
import { DarkTheme24Regular, Translate24Regular } from '@fluentui/react-icons'
import type { Dispatch } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../../hooks'
import type { SubmenuType } from '../types'

const useStyles = makeStyles({
  title: {
    display: 'flex',
    padding: `${tokens.spacingVerticalXXL} ${tokens.spacingHorizontalL} ${tokens.spacingVerticalL} ${tokens.spacingHorizontalL}`,
    paddingLeft: `${tokens.spacingHorizontalL}`, // force overwrite
  },
  itemText: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: tokens.spacingHorizontalXS,
    marginLeft: tokens.spacingHorizontalXS,
  },
  item: {
    width: '100%',
    padding: `${tokens.spacingHorizontalMNudge} ${tokens.spacingVerticalM}`,
    marginLeft: '0',
  },
})

type MainMenuProps = {
  setActiveSubmenu: Dispatch<SubmenuType>
}

const MainMenu = ({ setActiveSubmenu }: MainMenuProps) => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const { isDark } = useTheme()
  const appearance = isDark ? 'dark' : 'light'
  const selectedLanguage = i18n.resolvedLanguage ?? i18n.language ?? 'en'

  return (
    <>
      <Subtitle2 as="h2" className={classes.title}>
        {t('settings.title')}
      </Subtitle2>
      <AppItem
        icon={<Translate24Regular />}
        as="button"
        onClick={() => setActiveSubmenu('language')}
        className={classes.item}>
        <div className={classes.itemText}>
          <Body1Strong as="p">
            {t('settings.language')} {selectedLanguage !== 'en' && ' (Language)'}
          </Body1Strong>
          <Caption1 as="p">
            {t(`language.${selectedLanguage}`)}
            {selectedLanguage !== 'en' && ` (${t(`settings.${selectedLanguage}`, { lng: 'en' })})`}
          </Caption1>
        </div>
      </AppItem>

      <AppItem
        icon={<DarkTheme24Regular />}
        as="button"
        onClick={() => setActiveSubmenu('theme')}
        className={classes.item}>
        <div className={classes.itemText}>
          <Body1Strong as="p">{t('settings.appearance')}</Body1Strong>
          <Caption1 as="p">{t(`theme.${appearance}`)}</Caption1>
        </div>
      </AppItem>
    </>
  )
}

export { MainMenu }
